import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ToastContainer, toast } from "react-toastify";
import {
  openErrorMessage,
  openSuccessMessage,
} from "../../../store/slices/toastSlice";

const Toast = () => {
  const { error, success } = useSelector((state) => state.toast);
  const dispatch = useDispatch();

  useEffect(() => {
    success && toast.success(success);
    error && toast.error(error);
    setTimeout(() => {
      dispatch(openSuccessMessage(""));
      dispatch(openErrorMessage(""));
    }, 3000);
  }, [success, error]);

  return (
    <div>
      <ToastContainer theme="dark" />
    </div>
  );
};

export default Toast;
